import { ITileMapShip } from './tileMapShip'
import { tileMapShip } from './tileMapShip-sidecar'
import { tilesShip } from './tilesShip-sidecar'
import { tilesDataShip } from './tilesDataShip-sidecar'
import { assert } from '../lib/assert-sidecar'

let _isDirty = true
export function setDirty() {
  _isDirty = true
}

function getFrameIndex(l: any, r: any, t: any, b: any) {
  if (r && b && l && t) {
    return 7
  }

  if (r && l && b) {
    return 4
  }
  if (r && l && t) {
    return 10
  }
  if (t && b && r) {
    return 6
  }
  if (t && b && l) {
    return 8
  }

  if (r && b) {
    return 3
  }
  if (l && b) {
    return 5
  }
  if (t && r) {
    return 9
  }
  if (t && l) {
    return 11
  }

  if (t && b) {
    return 2
  }
  if (l && r) {
    return 1
  }

  if (b) {
    return 12
  }
  if (t) {
    return 13
  }
  if (l) {
    return 14
  }
  if (r) {
    return 15
  }
  return 0
}

export function tileTiles(obj: ITileMapShip) {
  if (!_isDirty) {
    return
  }

  let std = tilesDataShip.getStandard()
  let frames = std.floor.tiledFrameInfo
  assert.notNil(frames)
  let framesHull = std.hull.tiledFrameInfo
  assert.notNil(framesHull)
  let framesAsteroid = std.asteroid.tiledFrameInfo
  assert.notNil(framesAsteroid)
  let framesAsteroid2 = std.asteroid.tiledFrameInfo2
  assert.notNil(framesAsteroid2)

  const checkFloor = (x: number, y: number, ox: number, oy: number) => {
    let t = tileMapShip.getTile(obj, x + ox, y + oy)
    if (t && t.dataFloor == std.floor) {
      return t
    }
    return null
  }
  const checkHull = (x: number, y: number, ox: number, oy: number) => {
    let t = tileMapShip.getTile(obj, x + ox, y + oy)
    if (t && t.dataFloor == std.hull) {
      return t
    }
    return null
  }

  const checkAsteroid = (x: number, y: number, ox: number, oy: number) => {
    let t = tileMapShip.getTile(obj, x + ox, y + oy)
    if (t && t.dataFloor == std.asteroid) {
      return t
    }
    return null
  }

  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      {
        let a = checkFloor(i, j, 0, 0)

        if (a) {
          let l = checkFloor(i, j, -1, 0)
          let r = checkFloor(i, j, 1, 0)
          let t = checkFloor(i, j, 0, -1)
          let b = checkFloor(i, j, 0, 1)

          let f = getFrameIndex(l, r, t, b)
          tilesShip.setTiledFloor(a, frames[f])
        }
      }
      {
        let a = checkHull(i, j, 0, 0)

        if (a) {
          let l = checkHull(i, j, -1, 0)
          let r = checkHull(i, j, 1, 0)
          let t = checkHull(i, j, 0, -1)
          let b = checkHull(i, j, 0, 1)

          let f = getFrameIndex(l, r, t, b)
          tilesShip.setTiledFloor(a, framesHull[f])
        }
      }
      {
        let a = checkAsteroid(i, j, 0, 0)

        if (a) {
          let l = checkAsteroid(i, j, -1, 0)
          let r = checkAsteroid(i, j, 1, 0)
          let t = checkAsteroid(i, j, 0, -1)
          let b = checkAsteroid(i, j, 0, 1)

          if (a.asteroidType == 'rock') {
            let f = getFrameIndex(l, r, t, b)
            tilesShip.setTiledFloor(a, framesAsteroid[f])
          } else {
            let f = getFrameIndex(l, r, t, b)
            tilesShip.setTiledFloor(a, framesAsteroid2[f])
          }
        }
      }
    }
  }

  _isDirty = false
}
